import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { take, takeUntil } from "rxjs/operators";
import { CheckBrachAccessModel } from "src/app/gnr/data-center-process/chek-branch-access.model";
import { Cost } from "../../model/cost.model";
import { CostSpent } from "../../model/costspent.model";
import { Personnel, PersonnelRolesEnum } from "src/app/frontoffice/parties/model/personnel.model";
import { CostSpentFormSettingModel } from "../costspentformsetting.model";
import { LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { Validators } from "@angular/forms";
@Component({
  selector: "ngx-costspent-form",
  templateUrl: "./costspent-form.component.html",
  styleUrls: ["./costspent-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostSpentFormComponent extends BaseFormComponent<CostSpent> {
  cost: Cost;
  costList: Cost[] = [];
  deactivateSave: boolean;
  errorMessage: string;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private storage: LocalStoreManager) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.apiName = "CostSpent";
    this.label = this.translate("ClientApp.FrontOffice.Cost.SpentCost.spentMoney");
    super.ngOnInit();
    if (!this.model && !this.model?.Id) this.setMaxCode();
    this.FillData();
  }

  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(take(1))
      .subscribe((data: number) => {
        if (!this.model) this.model = new CostSpent();
        if (data) {
          this.model["Code"] = data;
        }
        this.setFormGroup(this.model);
      });
  }

  FillData() {
    const currentInformation = this.accountService.authService.currentInformation();
    const checkBranching = currentInformation.BranchingLightEnabled || currentInformation.BranchingAdvancedEnabled;

    if (checkBranching) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch/CostSpent")
        .pipe(take(1))
        .subscribe({
          next: (hbc: CheckBrachAccessModel) => {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Cost.SpentCost.HasBranchCommunication"),
                this.translate("ClientApp.FrontOffice.Cost.SpentCost.Attention")
              );
              this.deactivateSave = true;
              return;
            } else if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Cost.SpentCost.HasCallCenterCommunication"),
                this.translate("ClientApp.FrontOffice.Cost.SpentCost.Attention")
              );
              this.deactivateSave = true;
              return;
            }
          },
          error: (error) => this.getFailedHelper(error),
        });
    }
  }

  //چک کردن اینکه کاربر صندوقدار هست یا نه برای فعال بودن یا نبودن چک باکس کسر از موجودی صندوقدار
  checkTheRole() {
    const currentUser = this.accountService?.authService?.currentUser;
    this.httpCommonService
      .getList("Personnel")
      .pipe(take(1))
      .subscribe((data: Personnel[]) => {
        if (data) {
          const isCashier = data.some((f) => f.UserId === currentUser.Id && f.RolesTitle === PersonnelRolesEnum.Cashier);
          if (isCashier) {
            this.orignalColumns.find((f) => f.name === "DeductionForSetelment").formVisible = true;
            this.columns = this.orignalColumns.filter((f) => (!f.areaName || f.areaName === "default") && f.formVisible);
          }
        }
      });
  }

  async fillSubDetailLedger() {
    let costSpentFormSettingModel = <CostSpentFormSettingModel>this.storage.getData(ClearableCache.FormSetting);
    if (!costSpentFormSettingModel) {
      let result = await this.httpCommonService.getList("CostSpentFormSetting").pipe(take(1)).toPromise();
      if (result) {
        costSpentFormSettingModel = <CostSpentFormSettingModel>result[0];
        this.storage.savePermanentData(costSpentFormSettingModel, ClearableCache.FormSetting);
      }
    }
    this.model.Subledger = costSpentFormSettingModel.Subledger;
    this.model.DetailLedger = costSpentFormSettingModel.DetailLedger;
  }

  setdefault(): void {
    this.checkTheRole();
    if (this.model.SettlementId || this.model.DriverSettlementId) this.deactivateSave = true;
    if (!this.currentrow) this.fillSubDetailLedger();
  }

  setColumnAttribute() {
    super.setColumnAttribute();
    this.orignalColumns.forEach((x) => {
      if (x.name === "Subledger" || x.name === "DetailLedger") {
        const AccountingKind = this.accountService.authService.currentInformation().AccountingKind;
        x.formVisible =
          AccountingKind === SoftWareLicenseKind.AccountingWeb ||
          AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
          AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb;
      }
      if (x.name === "Code") x.isFloat = 1;
    });
  }

  isValid() {
    if (!this.formGroup.controls["CostId"].value) {
      this.errorMessage = this.translate("ClientApp.FrontOffice.Cost.SpentCost.SelectingCostGroupIsRequired");
      return false;
    }
    this.errorMessage = undefined;
    return true;
  }

  changValue($event) {
    if (
      $event.KeyName === "CostId" &&
      this.errorMessage.includes(this.translate("ClientApp.FrontOffice.Cost.SpentCost.SelectingCostGroupIsRequired"))
    ) {
      this.isValid();
    }
    if ($event.apiName.includes("CostGroup")) {
      const costGroupId = this.formGroup.controls["CostGroupId"].value;
      const branchId = this.accountService.authService.currentBranchId;

      var FindList = this.costList.filter(
        (f) => (f.CostGroupId === costGroupId || f.CostGroupId === 0) && f.Branch.some((z) => z.BranchId == branchId && z.IsActive)
      );

      this.setValue("CostId", null);

      if (FindList?.length == 0) {
        this.selectorService.setDataList("CostId", []);
        this.formGroup.controls["CostId"].disable();
      } else {
        this.selectorService.setDataList("CostId", Object.assign([], FindList));
        this.formGroup.controls["CostId"].enable();
      }
    }
  }

  CompleteData($event) {
    if ($event && $event.apiName === "Cost") {
      this.costList = $event.data;
      if (!this.formGroup.controls["CostGroupId"].value) this.formGroup.controls["CostId"].disable();
      else {
        const costGroupId = this.formGroup.controls["CostGroupId"].value;
        const branchId = this.accountService.authService.currentBranchId;
        var FindList = this.costList.filter(
          (f) => (f.CostGroupId === costGroupId || f.CostGroupId === 0) && f.Branch.some((z) => z.BranchId == branchId && z.IsActive)
        );
        this.selectorService.setDataList("CostId", Object.assign([], FindList));
      }
    }
  }
}
